import React from "react";

function MetadataField({
  label,
  value,
  variant = "readonly-input",
  className = "",
  inputClassName = "",
  valueClassName = "",
  style,
  id,
}) {
  const inputId =
    id ||
    `meta-${label ? String(label).toLowerCase().replace(/[^a-z0-9]/g, "-") : "field"}`;

  if (variant === "readonly-input") {
    return (
      <div className={`flex flex-col gap-1 min-w-0 overflow-hidden ${className}`}>
        <label
          htmlFor={inputId}
          className="text-xs text-secondary whitespace-nowrap cursor-default"
        >
          {label}
        </label>
        <input
          id={inputId}
          aria-label={label}
          className={`bg-transparent border-0 text-primary text-base p-0 m-0 overflow-hidden outline-none focus-visible:text-brand-accent-fg ${inputClassName}`}
          type="text"
          size={Math.max(String(value ?? "").length, 1)}
          readOnly
          disabled
          value={value || ""}
          style={style}
        />
      </div>
    );
  }

  return (
    <div className={`flex flex-col gap-1 min-w-0 overflow-hidden ${className}`}>
      <span className="text-xs text-secondary whitespace-nowrap">{label}</span>
      <span
        className={`text-base text-primary whitespace-nowrap overflow-hidden text-ellipsis ${valueClassName}`}
      >
        {value === 0 || value ? value : "\u00A0"}
      </span>
    </div>
  );
}

export default MetadataField;